import { themeOptions } from "styles/theme";

export const StylesMap = {
    row: "& .ReactVirtualized__Table__row",
    headerRow: "& .ReactVirtualized__Table__headerRow",
    headerColumn: "& .ReactVirtualized__Table__headerColumn",
};

export const styles = {
    [StylesMap.row]: {
        fontSize: 14,
        borderBottom: `1px solid ${themeOptions.palette.lighterGrey}`,
        cursor: "default",
    },
    [StylesMap.headerRow]: {
        borderBottom: `1px solid ${themeOptions.palette.grey}`,
        fontWeight: 400,
        textTransform: "capitalize",
    },
    [StylesMap.headerColumn]: {
        fontSize: 12,
        cursor: "default",
    },
    "& .ReactVirtualized__Grid__innerScrollContainer, .ReactVirtualized__Grid": {
        overflow: "visible !important", // required to make tooltips visible
    },
    "& .ReactVirtualized__Table__headerColumn:first-of-type, .ReactVirtualized__Table__rowColumn:first-of-type": {
        marginLeft: 0,
    },
};
